import script from "./sale_order.vue?vue&type=script&setup=true&lang=ts"
export * from "./sale_order.vue?vue&type=script&setup=true&lang=ts"

import "./sale_order.vue?vue&type=style&index=0&id=2c8197fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8197fa"]])

export default __exports__